// extracted by mini-css-extract-plugin
export var richContent = "rich-dato-cms-content-module--richContent--196ed";